import React, {Component} from 'react';
import {connect} from "react-redux";
import "./main.css"
import InputWithKeyboard from "../formElements/InputWithKeyboard";
import {addProduct, addQuickPosProduct, findProducts, setProductSelectList} from "../redux/actions";
import { PerfectScrollbarWithHotfix as PerfectScrollbar } from '../uiComponents/WrappedPerfectScrollBar';
import Translate from "localization/Translate";
import Product from "../redux/dto/product";
import closeImg from "./images/Erply/close.png";
import {displayPrice, numberIsOdd} from "../util/helperFunctions";
import {displayNetPrices} from "../redux/selectors";
import {Loader} from "./Loading";

const mapStateToProps = state => {
    return {
        productSelectList: state.rootReducer.productSelectList,
        warehouseID: state.rootReducer.warehouse.warehouseID,
        pointOfSaleID: state.rootReducer.pos.pointOfSaleID,
        editQuickPosProducts: state.rootReducer.editQuickPosProducts,
        currency: state.rootReducer.currency,
        displayNetPrices: displayNetPrices(state.rootReducer.erplyConf),
    }
};

const mapDispatchToProps = dispatch => {
    return {
        findProducts: (query, warehouseID, pointOfSaleID, onDone) => {
            dispatch(findProducts({searchNameIncrementally: query}, warehouseID, pointOfSaleID, result => {
                onDone();
                return setProductSelectList(result);
            }, result => {
                onDone();
                return setProductSelectList([]);
            }));
        },
        clearQuery: () => {
            dispatch(setProductSelectList([]));
        },
        setProduct: (product, amount=1) => {
            let productDTO = new Product(product.name, product.priceListPrice, product.priceListPriceWithVat, amount, product);
            dispatch(addProduct(productDTO));
        },
        addQuickPosProduct: (product) => {
            dispatch(addQuickPosProduct(product));
        }
    }
};

class ProductSearch extends Component{
    constructor(props) {
        super(props);
        this.state = {
            lastSearchTime: false,
            lastSearchQuery: false,
            searching: false
        }
    }

    componentWillUnmount() {
        this.props.clearQuery();
    }

    findProducts(query, time) {
        setTimeout(() => {
            if(time === this.state.lastSearchTime){
                this.props.findProducts(query, this.props.warehouseID, this.props.pointOfSaleID, () => {
                    this.setState({
                        searching: false
                    });
                });
            }
        }, 1000);
    }

    render() {
        let content;

        if(this.state.searching){
            content = (
                <Loader position={"absolute"}/>
            );
        }else if(this.props.productSelectList.length > 0){
            content = (
                <PerfectScrollbar style={{
                    width: "100%"
                }}>
                    <table className={'productSearchTable'}>
                        <tbody>
                            {this.props.productSelectList.map((product, index) => {
                                let liClass = (numberIsOdd(index + 1) ? ' productLineOdd' : '');
                                return (
                                    <tr
                                        key={index}
                                        onClick={e => {
                                            if(this.props.editQuickPosProducts){
                                                this.props.addQuickPosProduct(product);
                                            }else{
                                                this.props.setProduct(product, this.props.productAmount);
                                            }
                                            this.props.onSelect(product);
                                        }}
                                        className={liClass}
                                    >
                                        <td className={'boldText'}
                                            style={{
                                            textAlign: 'left'
                                        }}>
                                            { product.name }
                                        </td>
                                        <td>
                                            { product.code }
                                        </td>
                                        <td className={'boldText'}>
                                            { this.props.displayNetPrices ? displayPrice(product.price) : displayPrice(product.priceWithVat) } {this.props.currency}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </PerfectScrollbar>
            );
        }else if(this.state.lastSearchQuery.length > 2){
            if(typeof this.props.notFoundContent !== "undefined"){
                let NotFound = ({query}) => {
                    return this.props.notFoundContent(query);
                }
                content = <NotFound query={this.state.lastSearchQuery}/>
            }else{
                content = <div style={{margin: '1.43rem'}}><Translate id={'No products match the query'}/></div>
            }
        }

        return (
            <div style={{
                marginTop: '0.71rem',
                padding: '0 0.142857rem',
                fontSize: '1rem',
                display: 'flex'
            }}>
                <span style={{
                    display: 'block',
                    float: 'left',
                    padding: '0.71rem 1.43rem',
                    fontWeight: 'bold',
                    fontSize: '1.14rem'
                }}>
                    <Translate id={"Product search"}/>
                </span>
                <InputWithKeyboard
                    onInputChange={(value) => {
                        let time = Date.now();
                        this.setState({
                            lastSearchTime: time,
                            lastSearchQuery: value,
                        });
                        if(value.length > 2){
                            this.setState({
                                searching: true
                            });
                            this.findProducts(value, time);
                        }else{
                            // this.props.clearQuery();
                        }
                    }}
                    onDone={(value) => {
                        this.props.clearQuery();
                    }}
                    inputStyle={{
                        boxSizing: 'border-box',
                        height: '3.14rem',
                        color: '#808080'
                    }}
                    inputClass={'fullWidth roundButton'}
                    style={{
                        flex: 'auto'
                    }}
                />
                <span
                    style={{
                        padding: '1rem 1.79rem'
                    }}
                    onClick={this.props.onClose}
                >
                    <img src={closeImg} alt={'close'}/>
                </span>
                <div style={this.props?.productListStyle ?? {
                    position: 'absolute',
                    top: '4.29rem',
                    bottom: '13.3rem',
                    left: 0,
                    right: 0,
                    height: 'auto'
                }}>
                    { content }
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductSearch);
